import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
// import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Amplify, Auth, API } from "aws-amplify";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { TokenStorageService } from "./token.service";
import Swal from "sweetalert2";

export interface IUser {
  email: string;
  password: any;
  newPassword: any;
  username: any;
  oldPassword: string;
  showPassword: boolean;
  code: string;
  name: string;
  phone_number: string;
  familyName?: string;
  UserAttributes: {};
}
@Injectable({
  providedIn: "root",
})
export class CognitoService {
  private authenticationSubject: BehaviorSubject<any>;

  constructor(
    public http: HttpClient,
    private tokenService: TokenStorageService
  ) {
    Amplify.configure({
      Auth: environment.cognito,
      API: {
        endpoints: [
          {
            custom_header: async () => {
              return {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getAccessToken()
                  .getJwtToken()}`,
              };
            },
          },
        ],
      },
    });
    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }

  public signUp(user: IUser): Promise<any> {
    return Auth.signUp({
      username: user.email,
      password: user.password,
      attributes: {
        email: user.email,
        name: user.name,
        // family_name: "procurement",
        phone_number: "+91" + user.phone_number,
      },
    });
  }

  public confirmSignUp(user: IUser): Promise<any> {
    return Auth.confirmSignUp(user.email, user.code);
  }

  public signIn(user: IUser): Promise<any> {
    return Auth.signIn(user.email, user.password)
      .then((response) => {
        this.authenticationSubject.next(response);
        return response;
      })
      .catch((error) => {
        console.log("error:", error);
        switch (error.message) {
          case "Username should be either an email or a phone number.":
            Swal({
              text: "Username should be either an email or a phone number.",
            });
            break;
          case "Password did not conform with policy: Password not long enough":
            Swal({
              text: "Password did not conform with policy: Password not long enough.",
            });
            break;
          case "User is not confirmed.":
            Swal({ text: "User is not confirmed" });
            break;
          case "Incorrect username or password.":
            Swal({ text: error.message });
            break;
          case "User does not exist.":
            Swal({ text: "User does not exist." });
            break;
          default:
            Swal({ text: "Error" });
        }
      });
  }

  public signOut(): Promise<any> {
    return Auth.signOut().then(() => {
      this.authenticationSubject.next(false);
      this.tokenService.signOut();
    });
  }

  public isAuthenticated(): Promise<boolean> {
    if (this.authenticationSubject.value) {
      return Promise.resolve(true);
    } else {
      return this.getUser()
        .then((user: any) => {
          if (user) {
            console.log("@@user:", user);
            return true;
          } else {
            return false;
          }
        })
        .catch(() => {
          return false;
        });
    }
  }

  public getUser(): Promise<any> {
    return Auth.currentUserInfo();
  }
  public getCurrentSession(): Promise<any> {
    return Auth.currentSession();
  }
  public getCurrentUserToken(): Promise<any> {
    return Auth.currentUserInfo();
  }
  public updateUser(user: IUser): Promise<any> {
    return Auth.currentUserPoolUser().then((cognitoUser: any) => {
      return Auth.updateUserAttributes(cognitoUser, user);
    });
  }
  public forgotPassword(user: IUser): Promise<any> {
    return Auth.forgotPassword(user.email);
  }

  public confirmPassword(user: IUser): Promise<any> {
    return Auth.forgotPasswordSubmit(user.email, user.code, user.newPassword);
  }
  public updateNewPassword(userDetails: IUser): Promise<any> {
    return Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(
          user,
          userDetails.oldPassword,
          userDetails.newPassword
        );
      })
      .then((data) => {
        console.log(data);
        return data;
      })
      .catch((err) => {
        console.log(err);
        return err;
      });
  }
}
